const basicLangs = ['de', 'en', 'es', 'fr', 'it', 'ja', 'ko', 'pt', 'ru', 'zh']
const additionalLangs = ['ar', 'hu', 'id', 'km', 'mn', 'nl', 'no', 'pl', 'sm', 'th', 'to', 'vi', 'zh-hans']

const languageConfig = {
  // Used to load video streams in the correct language
  iso639Conversions: {
    // ISO 639-1: ISO 639-2
    da: 'dan',
    de: 'deu',
    en: 'eng',
    es: 'spa',
    fj: 'fij',
    fr: 'fra',
    hu: 'hun',
    id: 'ind',
    it: 'ita',
    ja: 'jpn',
    km: 'khm',
    ko: 'kor',
    mn: 'mon',
    nl: 'nld',
    no: 'nor',
    pl: 'pol',
    pt: 'por',
    ru: 'rus',
    sm: 'smo',
    th: 'tha',
    tl: 'tgl',
    to: 'ton',
    vi: 'vie',
    zh: 'zho',
    'zh-HK': 'yue',
  },
  additionalLangs,
  chineseLocales: ['zh-CN', 'zh-HK', 'zh-TW'],
  chineseLangMapping: {
    'zh-CN': 'zh-hans',
    'zh-HK': 'zh',
    'zh-TW': 'zh',
  },
  hreflangLanguageAliases: {
    jp: 'ja',
  },
  hreflangRegionAliases: {
    uk: 'GB',
  },
  complexSiteLanguages: ['en', 'es', 'fr', 'pt'],
  scheduleLanguages: basicLangs.concat(additionalLangs),
  languageTranslations: {
    pon: 'Mahsen en Pohnpei',
    fj: 'Vaka-Viti',
  },
}

export default languageConfig
